import * as angular from "angular";
import {ServiceAreasService} from "./services/service-areas-service.service";

angular
  .module('bringoz.admin.service-areas')
  .config(ServiceAreasConfig);

/* @ngInject */
function ServiceAreasConfig($stateProvider) {

  $stateProvider
    .state('service-areas-view', {
      parent: 'bringoz.site',
      url: '/administration/service-areas',
      template: '<service-areas-view feature-collection="featureCollection"></service-areas-view>',
      controller: function($scope, triBreadcrumbsService, polygonService, site) {

        // $scope.featureCollection = polygonService.getFeatureCollection(serviceAreas);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Service Areas"});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      // resolve: {
      //   serviceAreas: function(serviceAreasService: ServiceAreasService, site) {
      //     return serviceAreasService.getAll({});
      //     // var serviceAreaRef = $serviceArea();
      //     // return serviceAreaRef.$getAll().then((areaIds) => {
      //     //   return serviceAreaRef.$asyncValues(areaIds);
      //     // })
      //   }
      // }
    })
}
